"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAPIFrontend = exports.setHeaders = exports.setServerUrl = void 0;
const index_1 = require("./index");
let serverUrl = "";
let getHeaders = () => ({});
__exportStar(require("./index"), exports);
function setServerUrl(url) {
    serverUrl = url;
}
exports.setServerUrl = setServerUrl;
function setHeaders(headers) {
    if (typeof headers === "function") {
        getHeaders = headers;
    }
    else {
        getHeaders = () => headers;
    }
}
exports.setHeaders = setHeaders;
function getAPIFrontend() {
    return new Proxy({}, {
        get: (_, endpoint) => {
            if (endpoint === "$$typeof")
                return null;
            const headers = { "Content-Type": "application/json", ...getHeaders() };
            const method = (0, index_1.getMethodFromEndpoint)(endpoint);
            const url = (0, index_1.getUrlFromEndpoint)(endpoint);
            return async (params) => {
                let query = "";
                if (method === "GET" || method === "DELETE") {
                    query = Object
                        .entries(params)
                        // always stringify for values such as "null" or "123"
                        .map(([key, value]) => `${decodeURIComponent(key)}=${decodeURIComponent(JSON.stringify(value))}`)
                        .join("&");
                }
                let response;
                try {
                    response = await fetch(`${serverUrl}${url}?${query}`, {
                        method,
                        headers,
                        body: method === "POST" || method === "PUT" ? JSON.stringify(params) : undefined,
                    });
                }
                catch (e) {
                    return [null, "Service Unavailable", 503];
                }
                if (response.status === 200) {
                    try {
                        // I trust the backed
                        const json = await response.json();
                        return [json, null, 200];
                    }
                    catch (e) {
                        let error = "Parsing error.";
                        if (e !== null && typeof e === "object" && "message" in e && typeof e.message === "string")
                            error = e.message;
                        return [null, error, 200];
                    }
                }
                else {
                    let error = "Server error.";
                    try {
                        const json = await response.json();
                        if (typeof json.message === "string")
                            error = json.message;
                    }
                    catch (e) { }
                    return [null, error, response.status];
                }
            };
        },
    });
}
exports.getAPIFrontend = getAPIFrontend;
